/**
 * Safely parse a number from string or number input.
 */
export function safeParse(val: number | string) {
  const num = typeof val === 'number' ? val : parseFloat(val);

  return Number.isNaN(num) || !Number.isFinite(num) ? 0 : num;
}

export function safeParseNonZero(val: number | string, fallback = 1) {
  const num = typeof val === 'number' ? val : parseFloat(val);

  return Number.isNaN(num) || !Number.isFinite(num) || num === 0 ? fallback : num;
}

export function isSafeNumber(val: number) {
  return Number.isFinite(val) && val >= Number.MIN_SAFE_INTEGER && val <= Number.MAX_SAFE_INTEGER;
}
